import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { parApi } from "@/lib/partnerApi";
import { fmtDateTime } from "@/lib/residentApi";
import { useFloatingWindows } from "@/lib/floatingWindows";
import { whoLine } from "./MemoList";

/** Partner memos linked to this resident (staff view on the resident's Memo Board). */
export default function ResidentPartnerMemos({ rid }) {
  const [memos, setMemos] = useState([]);
  const { openWindow } = useFloatingWindows();
  useEffect(() => { parApi.get("/memos", { status: "all", resident_id: rid }).then((d) => setMemos(d.memos)).catch(() => {}); }, [rid]);
  if (!memos.length) return null;
  return (
    <div data-testid="resident-partner-memos" className="p-3 border border-sky-400/20 rounded-sm space-y-1.5">
      <div className="font-mono text-[9px] tracking-[0.22em] uppercase text-sky-300">Memos about this resident</div>
      {memos.map((m) => (
        <button key={m.id} type="button" onClick={() => openWindow("par_memos", { title: "Partner Memos", memoId: m.id })} data-testid={`resident-pmemo-${m.id}`}
          className="w-full text-left flex items-center gap-2 text-xs text-nex-silver/90 hover:text-nex-gold transition-colors">
          {m.priority === "urgent" && <AlertTriangle className="h-3 w-3 text-red-300" />}
          <span className="truncate flex-1">{m.subject}</span>
          <span className="text-nex-muted">{whoLine(m, "staff")} · {m.status} · {fmtDateTime(m.last_activity_at)}</span>
        </button>
      ))}
    </div>
  );
}
